import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PlatformLegalEntityBankAccountDto } from '@well/platform-administration/company/domain';
import { constants } from '@well/infra/constants';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabel } from 'primeng/floatlabel';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';

@Component({
  selector: 'well-platform-legal-entity-bank-account-inputs',
  standalone: true,
  imports: [FloatLabel,
    CommonModule,
    FormsModule,
    TranslateModule,
    InputTextModule, FormInlineErrorDirective],
  templateUrl: './platform-legal-entity-bank-account-inputs.component.html',
  styleUrls: ['./platform-legal-entity-bank-account-inputs.component.scss'],
  viewProviders: [constants.nestedTemplateFormsViewProviders]
})
export class PlatformLegalEntityBankAccountInputsComponent {
  @Input() platformLegalEntityBankAccountDto: PlatformLegalEntityBankAccountDto = new PlatformLegalEntityBankAccountDto();

}
